import OktaAuth from '@okta/okta-auth-js'
import OktaJWTVerifier from '@okta/jwt-verifier'

// Helpers
import { OktaConfig, isEnvironmentStage, isEnvironmentProd, isEnvironmentTest } from '../../../config'

/**
 * Returns okta client ID from environment variables
 * @param {String} tenantName tenant name of the embed client
 * @returns {String} client ID or empty string
 */
const getOktaClientId = (tenantName) => {
  // TODO: Figure out how to update env variables, Retrieve the
  // corresponding clientID for the tenant name passed
  if (isEnvironmentProd()) {
    return '0oa9h0giah9y5Tbpx297'
  }
  if (isEnvironmentStage()) {
    return '0oa9h0denvG5TP6vr297'
  }
  if (isEnvironmentTest()) {
    return '0oaarjczm1AXS2FpN297'
  }
  return '0oa10rz0ylrlqxb1j0h8'
}

/**
 * Returns instance of OktaAuth
 * @param {*} tenantName tenantName
 * @returns OktaAuth Instance
 */
const getEmbedOktaAuthInstance = (tenantName) => {
  const oktaAuth = new OktaAuth({
    url: OktaConfig.baseURL,
    issuer: OktaConfig.auth.issuer,
    clientId: getOktaClientId(tenantName),
    redirectUri: OktaConfig.auth.redirect_uri,
    pkce: false
  })
  return oktaAuth
}

/**
 * Returns Okta JWT Verifier instance
 * @param {*} tenantName
 * @returns OKTA JWT Verifier instance
 */
const getOktaJwtVerifierInstance = (tenantName) => {
  const oktaJWTVerifier = new OktaJWTVerifier({
    issuer: OktaConfig.auth.issuer,
    clientId: getOktaClientId(tenantName)
  })
  return oktaJWTVerifier
}

/**
 * Returns JWT token or error details
 * @param {String} sessionToken
 * @param {String} tenantName
 * @returns JWT token or error
 */
const getJwtFromSessionToken = (sessionToken, tenantName) => {
  const oktaBaseUrl = OktaConfig.baseURL
  const clientId = getOktaClientId(tenantName)
  const url =
    `${oktaBaseUrl}/oauth2/default/v1/authorize?` +
    'response_type=id_token&' +
    'scope=openid profile email embedded&' +
    'state=TEST&' +
    'nonce=TEST&' +
    `client_id=${clientId}&` +
    `redirect_uri=${OktaConfig.auth.redirect_uri}&` +
    `sessionToken=${sessionToken}`
  return fetch(url)
    .then((response) => {
      return response
    })
    .catch((error) => {
      return {
        error
      }
    })
}

export {
  getOktaClientId,
  getEmbedOktaAuthInstance,
  getOktaJwtVerifierInstance,
  getJwtFromSessionToken
}
